// External dependencies
import { useForm, FormProvider } from 'react-hook-form-latest';

import type { FC } from 'react';

// Internal components
import ReasonForChange from '@/components/Shared/Latest/ReasonForChange';
import { ModalActions, ModalContainer, ModalHeader } from '@/utils/modal';

interface BulkReasonForChangeProps {
  onClick: (reasonForChange?: string) => Promise<void>;
  closeModal: () => void;
  title: string;
}

interface BulkReasonForChangeFormData {
  reason_for_change?: string;
}

export const BulkReasonForChange: FC<BulkReasonForChangeProps> = ({ onClick, title, closeModal }) => {
  const formMethods = useForm<BulkReasonForChangeFormData>();
  const { handleSubmit } = formMethods;

  const onSubmit = (form: BulkReasonForChangeFormData): void => {
    onClick(form.reason_for_change);
    closeModal();
  };

  return (
    <ModalContainer size="narrow" className="bg-white">
      <ModalHeader title={`${title || 'Data has changed'}`} className="pa3 bb b--moon-gray w-100" />
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)} data-testid="bulk-reason-for-change-modal">
          <div className="pa3">
            <ReasonForChange />
          </div>
          <ModalActions className="pa3 mt3 bt b--moon-gray" onSubmit={handleSubmit(onSubmit)} onCancel={closeModal} />
        </form>
      </FormProvider>
    </ModalContainer>
  );
};
